export default {
    formatetime(data){
        if(!data){
            return ""
        }
        var date = new Date(Number(data)*1000)
        return date.getFullYear()+"-"+this.numberformate(date.getMonth()+1)+"-" + this.numberformate(date.getDate())+
        " "+ this.numberformate(date.getHours())+":"+this.numberformate(date.getMinutes())
        // +":"+this.numberformate(date.getSeconds())
    },
    formatedate(data){
        if(!data){
            return ""
        }
        var date = new Date(Number(data)*1000)
        return date.getFullYear()+"-"+this.numberformate(date.getMonth()+1)+"-" + this.numberformate(date.getDate())
    },
    numberformate(data){
     if(data<10){
       return '0'+data
     }else{
         return data
     }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/fun.js